export default __webpack_public_path__ + "static/media/dark-blue-marker.0a965d65.svg";